module.exports = __webpack_public_path__ + "static/img/fdasfasdf.176d160c.png";